import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../../shared/shared.module';
import { NgOtpInputModule } from  'ng-otp-input';
import { AuthServiceLocal } from '../auth.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SigninComponent } from './signin/signin.component';
import { ProfileComponent } from './profile/profile.component';
import { NodataComponent } from './nodata/nodata.component';
import { FilterdataPipe } from './filterdata.pipe';
import { QrCodeComponent } from './qr-code/qr-code.component';
const router: Routes = [
  {path:"",component:LoginComponent,
children:[
  { path: '', redirectTo: 'signin', pathMatch: 'full' },
  {path:"signin",component:SigninComponent, data: { state: 'signin' } },
  {path:"forgot-password",component:ForgotPasswordComponent, data: { state: 'forgot' } },
  {path:"card/:userId",component:ProfileComponent, data: { state: 'profile' } },
  {path:"qrcode",component:QrCodeComponent, data: { state: 'qrcode' } },
],
},
];

@NgModule({
  exports:[],
  imports: [CommonModule,SharedModule, RouterModule.forChild(router), FormsModule, ReactiveFormsModule, HttpClientModule,NgOtpInputModule],
  declarations: [LoginComponent, SigninComponent, ForgotPasswordComponent,ProfileComponent,NodataComponent, FilterdataPipe,QrCodeComponent],
  providers:[AuthServiceLocal]
})
export class LoginModule { }
